export const OPERATOR_COLORS = [
  '#2563eb',
  '#9333ea',
  '#be185d',
  '#b45309',
  '#047857',
  '#0e7490',
  '#4338ca',
  '#a21caf',
  '#b91c1c',
  '#4d7c0f',
  '#0369a1',
  '#7c3aed'
]

function rgb(color: string): number[] {
  return [1, 3, 5].map(offset => parseInt(color.slice(offset, offset + 2), 16))
}

function luminance(channels: number[]): number {
  const linear = channels.map(channel => {
    const value = channel / 255
    return value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4)
  })
  return linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722
}

export function contrastRatio(color: string, background: string): number {
  const a = luminance(rgb(color))
  const b = luminance(rgb(background))
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05)
}

/** Preserve the chosen hue, adjusting only when the actual bubble needs contrast. */
export function readableOperatorColor(color: string, background: string): string {
  if (!/^#[0-9a-f]{6}$/i.test(color) || !/^#[0-9a-f]{6}$/i.test(background)) return 'inherit'
  if (contrastRatio(color, background) >= 4.5) return color
  const target = contrastRatio('#ffffff', background) > contrastRatio('#000000', background) ? 255 : 0
  const channels = rgb(color)
  for (let amount = 0.01; amount <= 1.001; amount += 0.01) {
    const adjusted =
      '#' +
      channels
        .map(channel =>
          Math.round(channel + (target - channel) * Math.min(amount, 1))
            .toString(16)
            .padStart(2, '0')
        )
        .join('')
    if (contrastRatio(adjusted, background) >= 4.5) return adjusted
  }
  return target === 255 ? '#ffffff' : '#000000'
}
